import { writable } from 'svelte/store';
import type { IOptions } from './Interfaces';

export const optionsData = writable<IOptions>();
export const layoutId = writable<string>();

// wizData
export const settingsElementId = writable<string>();
export const cartItemElementId = writable<string>();
export const productId = writable<string>();
export const categoryId = writable<string>();
export const assetsURI = writable<string>();